export function horizon(){

  // ▼横スクロール ----------------------------------------------------------
  //▽ get Elements
  const body = document.querySelector('body');
  const header = document.querySelector('header');
  const logos = document.querySelector('.globalNav_lists_logos');
  const footer = document.querySelector('footer');
  const main = document.querySelector('main');
  const section = document.querySelectorAll('.js-secCmn');
  // const contents = document.querySelector('#contents');
  const mainArea = document.querySelector('#mainContents');
  const html = document.querySelector('html');
  //▽ set contents width
  let contentsW = 0;
  let section100 = '';
  let maxWidth = '';

  const setHeight = () => {
    body.style.height = innerHeight + 'px';
    header.style.height = innerHeight * 23 / 100 + 'px';
    logos.style.height = innerHeight * 23 / 100 + 'px';
    footer.style.height = innerHeight * 5 / 100 + 'px';
    main.style.height = innerHeight * 77 / 100 + 'px';
    main.style.paddingTop = innerHeight * 23 / 100 + 'px';
    mainArea.style.height = '100%';

    var orientation = window.orientation;
    if (orientation === 0) {
      if(window.innerWidth < 768){
        header.style.height = innerHeight * 16 / 100 + 'px';
        logos.style.height = innerHeight * 16 / 100 + 'px';
        footer.style.height = innerHeight * 5 / 100 + 'px';
        main.style.height = innerHeight * 84 / 100 + 'px';
        main.style.paddingTop = innerHeight * 16 / 100 + 'px';
      }
     /*  縦画面時の処理  */
    }
  }


  maxWidth = () => {
    let wW = window.innerWidth;
    if($('.js-secCmn-w100').length){
    section100 = document.querySelectorAll('.js-secCmn-w100');

      for(let i = 0; i < section100.length; i++){
        section100[i].style.width = wW + 'px';
      }
    }
  }


  const contentsResize = () =>{
    //▽ set contents width
    contentsW = 0;
    //▽ main add flex remove
    mainArea.style.display = "block";

    //▽ section loop
    for(let i = 0; i < section.length; i++){
      //▽ add all section's width to 'contentsW'
      contentsW += section[i].offsetWidth;
    }

    if($('.js-secCmn-w100').length){
      section100 = document.querySelectorAll('.js-secCmn-w100');
      for(let i = 0; i < section100.length; i++){
        contentsW += section100[i].offsetWidth;
      }
    }

    //▽ contentsW change style
    // html.style.width = contentsW + 'px';
    mainArea.style.width = contentsW + 'px';

    //▽ main add flex
    mainArea.style.display = "flex";
  }


  // ▲ end 横スクロール -----------------------------------------------------

  setHeight();
  maxWidth();
  contentsResize();

  // ▼ load時 最後までスクロール --------------------------------------------
  // let winW = window.innerWidth;
  // if(winW > 768) {
  // }
  // if($('.recipePage').length){
    // window.onload = () => {
    //   //   scrollTo(contentsW, 0);
    //   main.scrollLeft = contentsW;
    // }
    // window.addEventListener("load", function(){
    //   main.scrollLeft = contentsW;
    //   console.log(111);
    // });
  // }
  // ▲ end load時 最後までスクロール ----------------------------------------

  // var ref = document.referrer;             // リファラ情報を得る
  // var hereHost = window.location.hostname; // 現在ページのホスト(ドメイン)名を得る
  //
  // // ホスト名が含まれるか探す正規表現を作る(大文字・小文字を区別しない)
  // var sStr = "^https?://" + hereHost;
  // var rExp = new RegExp( sStr, "i" );
  //
  // // リファラ文字列を判別
  // // if( ref.length == 0 ) {
  // //     // リファラなしの場合
  // //     // alert("リファラ情報がありません");
  // //     main.scrollLeft = contentsW;
  // // }
  // // else if( ref.match( rExp ) ) {
  // if( !(ref.match( rExp )) ) {
  //     // マッチした場合＝アクセス元が自サイト内の場合
  //     // main.scrollLeft = document.querySelector('#menu').getBoundingClientRect().left + window.pageXOffset;
  //     main.scrollLeft = contentsW;
  // }
  // else {
  //   if($('.recipePage').length){
  //     main.scrollLeft = contentsW;
  //   }
  //   // main.scrollLeft = contentsW;
  //     // マッチしない場合＝アクセス元がサイト外の場合
  //     // alert("他のサイトから訪れました");
  // }

  //verify first time visitor or not in the pages
  // window.addEventListener('unload', function(e){
  //   // main.scrollLeft = contentsW;
  //   console.log(111);
  // });
  // window.addEventListener('unload', function(event) {
  //   console.log('I am the 3rd one.');
  //   main.scrollLeft = contentsW;
  // });
    var $currentpath = window.location.pathname.replace(`///`, '').replace(/./, '').replace(/_/, '-'); // 表示中のページのファイル名を取得する
    if ( !$currentpath ) {$currentpath = "homepage";} // トップページ（ファイル名が存在しない場合）に登録する任意のファイル名
    if ( window.name.indexOf( '#' + $currentpath )!=-1 ) { //ウィンドウ名に現在のファイル名が含まれるかチェック
        // alert( "I've seen you before!" ); // リロードや２度目以降の訪問時の処理
      if($('.recipePage').length){
        main.scrollLeft = contentsW;
        $('body').addClass('active');
      }
    } else {
        window.name = window.name + '#' + $currentpath; // ウィンドウ名の末尾にファイル名を追加する、#はエスケープ処理
        // alert( "It's nice to see you!" ); // 初回訪問時の処理
        main.scrollLeft = contentsW;
    }


  // ▼ ホイール 横スクロール ------------------------------------------------
  // window.addEventListener("wheel", e => {
  //   if (e.deltaX === 0) {
  //     // e.stopPropagation();
  //     // e.preventDefault();
  //     window.scrollBy((-(e.deltaY)), 0)
  //   }
  // })

  if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
    main.addEventListener('scroll', ()=>{
      if(document.querySelector('.pageTop')){
        if(main.scrollLeft <= contentsW - window.innerWidth * 2){
          document.querySelector('#pageFooter').classList.add('active')
        }else {
          document.querySelector('#pageFooter').classList.remove('active')
        }
      }
    });
  } else {
    window.onmousewheel = (e)=>{
    main.scrollLeft += e.wheelDelta / 2;
    main.scrollTop = 0;
    if(document.querySelector('.pageTop')){
      if(main.scrollLeft <= contentsW - window.innerWidth * 2){
        document.querySelector('#pageFooter').classList.add('active')
      }else {
        document.querySelector('#pageFooter').classList.remove('active')
      }
    }
  }

  }


  // ▲ end ホイール 横スクロール --------------------------------------------

  // ▼ リサイズ時 width調節 -------------------------------------------------
  window.addEventListener('resize', ()=>{
    setHeight();
    maxWidth();
    contentsResize();
  });
  window.addEventListener("orientationchange", function() {
    // location.reload();
    main.scrollLeft = contentsW;
    setHeight();
    maxWidth();
    contentsResize();
  });
  // ▼ end リサイズ時 width調節 ---------------------------------------------
}
